import React, { useState, useEffect } from "react";
import {
  Grid,
  TextField,
  MenuItem,
  Box,
  Typography,
  IconButton,
  Menu,
} from "@mui/material";
import axios from "axios";
import {
  AUDIT_AGENT_PERFORMANCE,
  AUDIT_CALLING_REPORT,
  DOWNLOAD_AUDIT_AGENT_REPORT,
  DOWNLOAD_AUDIT_CALL_REPORT,
  OUTGOING_CALL_REPORT,
  OUTGOING_CALL_STATS_REPORT,
} from "../../constants";
import PieChartComponent from "./PieChartComponent";
import BarChartComponent from "./BarChartComponent";
import AgentOverallPerformanceComponent from "./AgentOverallPerformance";
import AgentWiseSummaryReportComponent from "./AgentWiseSummaryReport";
import dayjs from "dayjs";
import Loader from "../reusable Component/Loader";
import FilterComponent from "./FilterComponent";
import FilterListIcon from "@mui/icons-material/FilterList";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import CallFilterComponent from "./CallFilterComponent";
import OutgoingCallDistributionComponent from "./OutgoingCallDistribution";
import OutgoingCallDistributionByAgentComponent from "./OutgoinCallDistributionByAgent";

const buttonStyle = {
  border: "1px solid #fff",
  borderRadius: "4px",
  margin: "5px",
  width: "40px",
  height: "40px",
  justifyContent: "center",
  alignItems: "center",
  backgroundColor: "#097969",
  color: "#fff",
  transition: "background-color 0.3s, transform 0.2s",
  boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.2)",
};

const hoverEffects = (e, isHovering) => {
  e.currentTarget.style.backgroundColor = isHovering ? "#0B9B73" : "#097969";
  e.currentTarget.style.transform = isHovering ? "scale(1.05)" : "scale(1)";
};

const AgentNameOption = [
  { label: "Yamini Dewangan", value: "Yamini Dewangan" },
];

const today = dayjs().startOf("day");

function AuditSupervisorDashboardComponent({ dateFilter }) {
  const [filters, setFilters] = useState({
    startDate: today.subtract(6, "day").format("YYYY-MM-DD"),
    endDate: today.format("YYYY-MM-DD"),
    agentName: "",
  });
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  // Fetch data from the API
  const fetchData = async () => {
    setLoading(true);
    try {
      const { startDate, endDate, agentName } = filters;

      // Build query parameters dynamically
      const queryParams = new URLSearchParams();
      if (startDate) queryParams.append("startDate", startDate);
      if (endDate) queryParams.append("endDate", endDate);
      if (agentName) queryParams.append("agentName", agentName);

      const response = await axios.get(
        `${AUDIT_AGENT_PERFORMANCE}?${queryParams.toString()}`
      );
      setData(response.data.data);
      console.log(response.data.data);
    } catch (error) {
      console.error("Error fetching data", error);
    } finally {
      setLoading(false);
    }
  };

  const [filtersLoaded1, setFiltersLoaded1] = useState(false); // Track if filters are loaded

  useEffect(() => {
    // Load filters from localStorage on page load
    const savedFilters = localStorage.getItem("filters");

    if (savedFilters) {
      const loadedFilters = JSON.parse(savedFilters);

      // Check if the filters have changed compared to the initial state
      if (
        loadedFilters.startDate !== filters.startDate ||
        loadedFilters.endDate !== filters.endDate ||
        loadedFilters.agentName !== filters.agentName
      ) {
        setFilters(loadedFilters); // Only set the new filters if they are different
      }
    }

    // Set filtersLoaded to true after initial load to prevent premature API call
    setFiltersLoaded1(true);
  }, []); // This runs only once on initial load

  useEffect(() => {
    // Only fetch the data if filters are loaded and filters state has changed
    if (
      filtersLoaded1 &&
      JSON.stringify(filters) !==
        JSON.stringify({
          startDate: dayjs().subtract(7, "days").toDate(),
          endDate: dayjs().toDate(),
          agentName: "",
        })
    ) {
      fetchData(); // Fetch data if filters have changed
    }
  }, [filters, filtersLoaded1]); // Re-fetch when filters change

  const handleFilterChange = (key, value) => {
    if (key === "dateRange") {
      // Handle predefined ranges
      const today = dayjs();
      let startDate = "";
      let endDate = today.format("YYYY-MM-DD");

      switch (value) {
        case "Today":
          startDate = endDate;
          break;
        case "Yesterday":
          startDate = endDate = today.subtract(1, "day").format("YYYY-MM-DD");
          break;
        case "Last 7 Days":
          startDate = today.subtract(7, "days").format("YYYY-MM-DD");
          break;
        case "Custom":
          startDate = filters.startDate; // Keep existing custom dates
          endDate = filters.endDate;
          break;
        default:
          startDate = "";
          endDate = "";
      }

      setFilters((prevFilters) => ({
        ...prevFilters,
        dateRange: value,
        startDate,
        endDate,
      }));
    } else {
      // Handle other filter changes
      setFilters((prevFilters) => ({
        ...prevFilters,
        [key]: value,
      }));
    }
  };

  const [filterShow, setFilterShow] = useState(false);

  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleExport = async (type) => {
    console.log(`Exporting as ${type}`);
    setLoading(true);
    try {
      const { startDate, endDate, agentName } = filters;

      // Build query parameters dynamically
      const queryParams = new URLSearchParams();
      if (startDate) queryParams.append("startDate", startDate);
      if (endDate) queryParams.append("endDate", endDate);
      if (agentName) queryParams.append("agentName", agentName);
      queryParams.append("format", type);

      const response = await axios.get(
        `${DOWNLOAD_AUDIT_AGENT_REPORT}?${queryParams.toString()}`,
        {
          responseType: "blob", // To handle file downloads
        }
      );

      const blob = new Blob([response.data], {
        type: response.headers["content-type"],
      });

      if (type.toLowerCase() === "html") {
        // Open HTML in a new tab
        const url = window.URL.createObjectURL(blob);
        window.open(url, "_blank");
        window.URL.revokeObjectURL(url);
        console.log("HTML file opened in new tab.");
      } else {
        // Handle file download for other formats
        const contentDisposition = response.headers["content-disposition"];
        const defaultFilename = `Agentreport.${type.toLowerCase()}`;
        const filename = contentDisposition
          ? contentDisposition.split("filename=")[1]?.replace(/"/g, "") ||
            defaultFilename
          : defaultFilename;

        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);

        console.log(`${type} file downloaded successfully.`);
      }

      handleClose();
    } catch (error) {
      console.error("Error downloading file:", error);
      handleClose();
    } finally {
      setLoading(false);
    }
  };

  const [callfilters, setCallFilters] = useState({
    startDate: dayjs().subtract(7, "days").toDate(), // 7 days ago
    endDate: dayjs().toDate(), // Today
    agentName: "",
  });
  

  const [incomingOverallStats, setIncomingOverallStats] = useState([]);
  const [incomingEmployeeStats, setIncomingEmployeeStats] = useState([]);

  const fetchIncomingCallStatistics = () => {
    const { startDate, endDate } = callfilters;

    const formattedStartDate = dayjs(startDate).format("YYYY-MM-DD");
    const formattedEndDate = dayjs(endDate).format("YYYY-MM-DD");

    const queryParams = new URLSearchParams();
    queryParams.append("startDate", formattedStartDate);
    queryParams.append("endDate", formattedEndDate);
    

    axios
      .get(`${AUDIT_CALLING_REPORT}?${queryParams.toString()}`)
      .then((response) => {
        const { data, overallStats, employeeStats } = response.data;
        setIncomingOverallStats(overallStats);
        setIncomingEmployeeStats(employeeStats);
        
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const [outMetrics, setOutMetrics] = useState([]);
  const [outCallStatistics, setOutCallStatistics] = useState([]);

  const [overallStats, setOverallStats] = useState([]);
  const [employeeStats, setEmployeeStats] = useState([]);

  const fetchOutgoingCallData = () => {
    const { startDate, endDate, agentName } = callfilters;

    const formattedStartDate = dayjs(startDate).format("YYYY-MM-DD");
    const formattedEndDate = dayjs(endDate).format("YYYY-MM-DD");

    const queryParams = new URLSearchParams();
    queryParams.append("startDate", formattedStartDate);
    queryParams.append("endDate", formattedEndDate);
    if (agentName) {
      queryParams.append("agentName", agentName);
    }
    

    axios
      .get(`${OUTGOING_CALL_STATS_REPORT}?${queryParams.toString()}`)
      .then((response) => {
        const { overallStats, employeeStats } = response.data;
        setOverallStats(overallStats);
        setEmployeeStats(employeeStats);
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const [filtersLoaded, setFiltersLoaded] = useState(false); // Track if filters are loaded

  useEffect(() => {
    // Load filters from localStorage on page load
    const savedFilters = localStorage.getItem("callfilters");

    if (savedFilters) {
      const filters = JSON.parse(savedFilters);

      // Check if filters have changed compared to the initial state
      if (
        filters.startDate !== callfilters.startDate ||
        filters.endDate !== callfilters.endDate ||
        filters.agentName !== callfilters.agentName
      ) {
        setCallFilters(filters); // Only set the new filters if they are different
      }
    }

    // Set filtersLoaded to true after initial load to prevent premature API call
    setFiltersLoaded(true);
  }, []); // This runs only once on initial load

  useEffect(() => {
    // Only fetch the statistics if filters are loaded and callfilters state has changed
    if (
      filtersLoaded &&
      JSON.stringify(callfilters) !==
        JSON.stringify({
          startDate: dayjs().subtract(7, "days").toDate(),
          endDate: dayjs().toDate(),
          agentName: "",
        })
    ) {
      fetchIncomingCallStatistics();
      fetchOutgoingCallData();
    }
  }, [callfilters, filtersLoaded]); // Re-fetch when filters change

  const [callFilterShow, setCallFilterShow] = useState(false);

  const [anchorcallEl, setAnchorCallEl] = useState(null);

  const handleCallClick = (event) => {
    setAnchorCallEl(event.currentTarget);
  };

  const handleCallClose = () => {
    setAnchorCallEl(null);
  };

  const handleCallExport = async (type) => {
    console.log(`Exporting as ${type}`);
    setLoading(true);
    try {
      const { startDate, endDate, agentName } = callfilters;

      // Build query parameters dynamically
      const queryParams = new URLSearchParams();
      if (startDate) queryParams.append("startDate", startDate);
      if (endDate) queryParams.append("endDate", endDate);
      if (agentName) queryParams.append("agentName", agentName);
      queryParams.append("format", type);

      const response = await axios.get(
        `${DOWNLOAD_AUDIT_CALL_REPORT}?${queryParams.toString()}`,
        {
          responseType: "blob", // To handle file downloads
        }
      );

      const blob = new Blob([response.data], {
        type: response.headers["content-type"],
      });

      if (type.toLowerCase() === "html") {
        // Open HTML in a new tab
        const url = window.URL.createObjectURL(blob);
        window.open(url, "_blank");
        window.URL.revokeObjectURL(url);
        console.log("HTML file opened in new tab.");
      } else {
        // Handle file download for other formats
        const contentDisposition = response.headers["content-disposition"];
        const defaultFilename = `Agentreport.${type.toLowerCase()}`;
        const filename = contentDisposition
          ? contentDisposition.split("filename=")[1]?.replace(/"/g, "") ||
            defaultFilename
          : defaultFilename;

        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);

        console.log(`${type} file downloaded successfully.`);
      }

      handleCallClose();
    } catch (error) {
      console.error("Error downloading file:", error);
      handleCallClose();
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {loading && <Loader open={loading} />}

      {/* Filter and Export Actions */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-end",
          width: "100%",
          marginBottom: 1,
        }}
      >
        {filterShow && (
          <FilterComponent
            filters={filters}
            setFilters={setFilters}
            data={data}
            setFilterShow={setFilterShow}
          />
        )}

        <IconButton
          onClick={() => setFilterShow((prev) => !prev)}
          style={buttonStyle}
          onMouseEnter={(e) => hoverEffects(e, true)}
          onMouseLeave={(e) => hoverEffects(e, false)}
        >
          <FilterListIcon />
        </IconButton>

        <IconButton
          onClick={handleClick}
          style={buttonStyle}
          onMouseEnter={(e) => hoverEffects(e, true)}
          onMouseLeave={(e) => hoverEffects(e, false)}
        >
          <FileDownloadIcon />
        </IconButton>

        <Menu
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={handleClose}
          anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
          transformOrigin={{ vertical: "top", horizontal: "center" }}
        >
          {/* <MenuItem onClick={() => handleExport("PDF")}>Export as PDF</MenuItem> */}
          <MenuItem onClick={() => handleExport("CSV")}>Export as CSV</MenuItem>
          <MenuItem onClick={() => handleExport("HTML")}>Show as HTML</MenuItem>
        </Menu>
      </Box>

      {/* Reports and Charts */}
      <Grid container spacing={2} wrap="wrap">
        <Grid item xs={12}>
          <AgentOverallPerformanceComponent data={data} filters={filters} />
        </Grid>

        <Grid item xs={12}>
          <AgentWiseSummaryReportComponent data={data} />
        </Grid>

        {/* Call Filter and Export Actions */}
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-end",
            width: "100%",
            marginBottom: 1,
            marginLeft: 1,
            marginTop: 2,
          }}
        >
          {callFilterShow && (
            <CallFilterComponent
              filters={callfilters}
              setFilters={setCallFilters}
              data={incomingEmployeeStats}
              setFilterShow={setCallFilterShow}
              agentNameOptions={AgentNameOption}
            />
          )}

          <IconButton
            onClick={() => setCallFilterShow((prev) => !prev)}
            style={buttonStyle}
            onMouseEnter={(e) => hoverEffects(e, true)}
            onMouseLeave={(e) => hoverEffects(e, false)}
          >
            <FilterListIcon />
          </IconButton>

          <IconButton
            onClick={handleCallClick}
            style={buttonStyle}
            onMouseEnter={(e) => hoverEffects(e, true)}
            onMouseLeave={(e) => hoverEffects(e, false)}
          >
            <FileDownloadIcon />
          </IconButton>

          <Menu
            anchorEl={anchorcallEl}
            open={Boolean(anchorcallEl)}
            onClose={handleCallClose}
            anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
            transformOrigin={{ vertical: "top", horizontal: "center" }}
          >
            {/* <MenuItem onClick={() => handleCallExport("PDF")}>
              Export as PDF
            </MenuItem> */}
            <MenuItem onClick={() => handleCallExport("CSV")}>
              Export as CSV
            </MenuItem>
            <MenuItem onClick={() => handleCallExport("HTML")}>
              Show as HTML
            </MenuItem>
          </Menu>
        </Box>

        <Grid item xs={12} sm={6}>
          <PieChartComponent
            metricData={incomingOverallStats}
            callfilters={callfilters}
          />
        </Grid>

        <Grid item xs={12} sm={6}>
          <BarChartComponent
            callStatistics={incomingEmployeeStats}
            callfilters={callfilters}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
            <OutgoingCallDistributionComponent
              metricData={overallStats}
              callfilters={callfilters}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <OutgoingCallDistributionByAgentComponent
              callStatistics={employeeStats}
              metricData={overallStats}
              callfilters={callfilters}
            />
          </Grid>
      </Grid>
    </>
  );
}

export default AuditSupervisorDashboardComponent;
